import React, { useState } from "react";
import Card from "@/components/Card";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestSel } from "@/features/backtest";
import { Col, Row, Tabs, Typography } from "antd";

import CandleStickChart from "./CandleStickChart";

const { TabPane } = Tabs;

export default () => {
  const strategyOhlc = useRootSelector(BacktestSel.strategyOhlc);
  const strategyTransaction = useRootSelector(BacktestSel.strategyTransaction);
  const [selection, setSelection] = useState(strategyOhlc.length > 0 ? strategyOhlc[0].symbol : undefined);

  return (
    <Row>
      <Col span={24}>
        <Card title={"Strategy Backtest Historical Charts"}>
          {strategyOhlc.length > 0 ? (
            <Tabs activeKey={selection} onChange={setSelection}>
              {strategyOhlc.map(e => (
                <TabPane tab={e.symbol} key={e.symbol}>
                  <CandleStickChart
                    ticker={e.symbol}
                    data={e.data}
                    indicators={e.indicators}
                    transactions={strategyTransaction.filter(t => t.symbol === e.symbol)}
                  />
                </TabPane>
              ))}
            </Tabs>
          ) : (
            <Typography.Paragraph>
              Historical data is not saved in snapshot. Please rerun the backtest if you wish to see the historical ohlc
              + indicator data
            </Typography.Paragraph>
          )}
        </Card>
      </Col>
    </Row>
  );
};
